import { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  GatewayCompaniesContractsInfoItem,
  GatewayCompaniesContractsUpdateInfo,
} from "../../features/api-interfaces";
import { useGetGatewayCompaniesContractsUpdateInfoQuery } from "../../features/api";
import { RegisterInfo } from "./RegisterInfo";

//=================================================================
// GW契約内容更新の画面クラス
//概要：事業者情報更新画面のGW名のリンクから遷移、GWの更新を行う
//
//前の画面からの必要なパラメーター
//GWコード     gatewayNo(パラメータ)
//事業者コード cpCode(パラメータ)
//
//呼び出し元：事業者情報更新画面もしくはGW一覧ValueGwName
//遷移先：このページに来る前の事業者情報更新画面
//戻り先：このページに来る前の事業者情報更新画面
//
//==================================================================

export const UpdateInfo = () => {
  //クエリパラメータとパスパラメータ
  const { gwCompanyCode, gatewayNo } = useParams();

  //取得API用のパラメーターの要素
  const params: GatewayCompaniesContractsInfoItem = {
    gwCompanyCode: String(gwCompanyCode),
    gatewayNo: Number(gatewayNo),
  };

  const { data, refetch } =
    useGetGatewayCompaniesContractsUpdateInfoQuery(params);
  const registeredData = data as GatewayCompaniesContractsUpdateInfo;

  useEffect(() => {
    refetch();
  }, [refetch]);

  return <RegisterInfo registeredData={registeredData} refetch={refetch} />;
};
